import { track } from "../track";

interface Params {
  quiz_id?: string;
  name?: string;
  email?: string;
}

export const trackOnBoSignUpFail = (params: Params) =>
  track({ event: "on_bo_sign_up_fail", ...params });
